/**
 * Visual Code Canvas Templates
 * Pre-built examples for students to learn from
 */

export const codeCanvasTemplates = [
  {
    id: 'blank',
    name: '✨ Blank Canvas',
    description: 'Start from scratch!',
    difficulty: 'beginner',
    code: `// Your creative code here!
// Try: turtle.forward(100)

`,
    thumbnail: '🎨'
  },
  {
    id: 'square',
    name: '⬜ Simple Square',
    description: 'Draw a basic square',
    difficulty: 'beginner',
    code: `// Draw a square
for (let i = 0; i < 4; i++) {
  turtle.forward(100);
  turtle.right(90);
}`,
    thumbnail: '⬜'
  },
  {
    id: 'rainbow_spiral',
    name: '🌈 Rainbow Spiral',
    description: 'Colorful spiral pattern',
    difficulty: 'beginner',
    code: `// Rainbow spiral
const colors = ['red', 'orange', 'yellow', 'green', 'blue', 'purple'];

for (let i = 0; i < 360; i++) {
  turtle.color(colors[i % colors.length]);
  turtle.forward(i);
  turtle.right(59);
}`,
    thumbnail: '🌈'
  },
  {
    id: 'flower',
    name: '🌸 Flower Pattern',
    description: 'Draw a beautiful flower',
    difficulty: 'intermediate',
    code: `// Draw a flower
turtle.color('pink');

for (let i = 0; i < 36; i++) {
  turtle.circle(50);
  turtle.right(10);
}

// Draw center
turtle.penup();
turtle.goto(0, 0);
turtle.pendown();
turtle.color('yellow');
turtle.dot(30);`,
    thumbnail: '🌸'
  },
  {
    id: 'star',
    name: '⭐ Star',
    description: 'Perfect 5-point star',
    difficulty: 'beginner',
    code: `// Draw a star
turtle.color('gold');
turtle.width(3);

for (let i = 0; i < 5; i++) {
  turtle.forward(100);
  turtle.right(144);
}`,
    thumbnail: '⭐'
  },
  {
    id: 'spiral_squares',
    name: '🎆 Spiral Squares',
    description: 'Rotating squares getting bigger',
    difficulty: 'intermediate',
    code: `// Spiral squares
const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8'];

for (let size = 10; size < 200; size += 10) {
  turtle.color(colors[(size / 10) % colors.length]);
  
  for (let i = 0; i < 4; i++) {
    turtle.forward(size);
    turtle.right(90);
  }
  
  turtle.right(10);
}`,
    thumbnail: '🎆'
  },
  {
    id: 'hexagon_pattern',
    name: '⬡ Hexagon Pattern',
    description: 'Tessellating hexagons',
    difficulty: 'intermediate',
    code: `// Hexagon pattern
function hexagon(size) {
  for (let i = 0; i < 6; i++) {
    turtle.forward(size);
    turtle.right(60);
  }
}

turtle.color('#3498db');
turtle.width(2);

for (let i = 0; i < 6; i++) {
  hexagon(50);
  turtle.penup();
  turtle.forward(50);
  turtle.right(60);
  turtle.forward(50);
  turtle.left(60);
  turtle.pendown();
}`,
    thumbnail: '⬡'
  },
  {
    id: 'mandala',
    name: '🎭 Mandala',
    description: 'Intricate mandala design',
    difficulty: 'advanced',
    code: `// Mandala pattern
const colors = ['#FF6B9D', '#C44569', '#FEA47F', '#F97F51'];

for (let layer = 0; layer < 4; layer++) {
  turtle.color(colors[layer]);
  
  for (let i = 0; i < 36; i++) {
    turtle.circle(50 + layer * 20);
    turtle.right(10);
    
    // Add detail
    turtle.forward(10);
    turtle.backward(10);
  }
}

// Center circle
turtle.penup();
turtle.goto(0, 0);
turtle.pendown();
turtle.color('#fff');
turtle.dot(20);`,
    thumbnail: '🎭'
  },
  {
    id: 'tree',
    name: '🌲 Fractal Tree',
    description: 'Beautiful fractal tree',
    difficulty: 'advanced',
    code: `// Fractal tree
function tree(length) {
  if (length < 5) return;
  
  turtle.forward(length);
  
  // Right branch
  turtle.right(20);
  tree(length * 0.7);
  
  // Left branch
  turtle.left(40);
  tree(length * 0.7);
  
  // Return to position
  turtle.right(20);
  turtle.backward(length);
}

turtle.color('#8B4513');
turtle.width(2);
turtle.left(90);  // Point up
turtle.penup();
turtle.goto(0, -150);
turtle.pendown();

tree(80);`,
    thumbnail: '🌲'
  },
  {
    id: 'fireworks',
    name: '🎆 Fireworks',
    description: 'Explosive burst pattern',
    difficulty: 'intermediate',
    code: `// Fireworks burst
const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#FFD93D'];

for (let i = 0; i < 36; i++) {
  turtle.color(colors[Math.floor(Math.random() * colors.length)]);
  turtle.width(2);
  
  turtle.forward(100);
  
  // Create sparkle
  for (let j = 0; j < 5; j++) {
    turtle.forward(10);
    turtle.backward(10);
    turtle.right(72);
  }
  
  turtle.backward(100);
  turtle.right(10);
}`,
    thumbnail: '🎆'
  },
  {
    id: 'wave',
    name: '🌊 Wave Pattern',
    description: 'Flowing wave design',
    difficulty: 'intermediate',
    code: `// Wave pattern
turtle.penup();
turtle.goto(-200, 0);
turtle.pendown();

const colors = ['#00B4DB', '#0083B0', '#006494'];

for (let wave = 0; wave < 3; wave++) {
  turtle.color(colors[wave]);
  turtle.width(3);
  
  turtle.penup();
  turtle.goto(-200, wave * 30);
  turtle.pendown();
  
  for (let x = 0; x < 400; x += 5) {
    const y = Math.sin(x / 20) * 30 + wave * 30;
    turtle.goto(x - 200, y);
  }
}`,
    thumbnail: '🌊'
  },
  {
    id: 'geometric',
    name: '🔷 Geometric Art',
    description: 'Modern geometric design',
    difficulty: 'advanced',
    code: `// Geometric art
const shapes = [
  { sides: 3, size: 80, color: '#FF6B6B' },
  { sides: 4, size: 70, color: '#4ECDC4' },
  { sides: 5, size: 60, color: '#45B7D1' },
  { sides: 6, size: 50, color: '#FFA07A' }
];

shapes.forEach(shape => {
  turtle.color(shape.color);
  turtle.width(3);
  
  const angle = 360 / shape.sides;
  for (let i = 0; i < shape.sides; i++) {
    turtle.forward(shape.size);
    turtle.right(angle);
  }
  
  turtle.right(15);
});`,
    thumbnail: '🔷'
  }
];

// Get templates by difficulty
export const getTemplatesByDifficulty = (difficulty) => {
  return codeCanvasTemplates.filter(t => t.difficulty === difficulty);
};

// Get random template
export const getRandomTemplate = () => {
  const templates = codeCanvasTemplates.filter(t => t.id !== 'blank');
  return templates[Math.floor(Math.random() * templates.length)];
};

export default codeCanvasTemplates;
